import React, {useContext, useEffect, useState } from 'react'
import axios from 'axios';


export default function Pdfpaysbulletin(props) {
    //Recherche le Bulletin du Pays en cours
   const [objpaysbulletin, SetObjpaysbulletin] = useState({                
           sourceinfo: "",
           dateCreation: "",
           bulletinPdf: null,
           bulletinImage: null,
           bulletinAudio: null,
           alertMessage: "",
           pays: ""
       })
  
   // eagrimet.online
  // const urlgetpaysbulletin = `http://localhost:8000/eagrimetApi/paysBulletin/?pays=${props.payscourant}`   
   const urlgetpaysbulletin = `https://eagrimet.online/eagrimetApi/paysBulletin/?pays=${props.payscourant}`   
   const  axiosconf = {
        headers: {
        "Content-Type": "application/json",
        Authorization: "Token f976960761d6c971c5be927bb45c4abfa1fcc352",
        }
     };

     useEffect(() => {
    const fetchAdminpays = async () => {
      await axios
        .get(urlgetpaysbulletin, axiosconf)
        .then((resultat) => {
          let result = resultat.data.map(r => {
                        //console.log(r.region); 
                        Object.assign(objpaysbulletin, r)                          
                        SetObjpaysbulletin({...objpaysbulletin,  sourceinfo : r.sourceinfo, alertMessage : r.alertMessage, bulletinPdf: r.bulletinPdf})                                           
                        }) 
        })
        .catch((error) => {
          console.error(error);
        });
    };
    fetchAdminpays();
  }, []);
  return (
    <div><label for="bulletinPdf" className="form-label"><a href={objpaysbulletin.bulletinPdf} target="_blank">Bulletin National</a></label> </div>
  )
}
